export const listPoze = [
    {
        img: "about us.jpg",
        subtext: "idk"
    },
    {
        img: "coordonatori.jpg",
        subtext: "idc"
    },
    {
        img: "volutari.jpg",
        subtext: "idc"
    }
];


